<app-navbar title="Lista szablonów ">
	<div class="d-flex flex-row-reverse">
		<button
			class="me-2 create-new-departure-button"
			mat-raised-button
			color="primary"
			(click)="createTemplate(TransportSide.DEPARTURE)"
		>
			Utwórz nowy szablon wyjazdowy
		</button>
		<button
			class="me-2 create-new-return-button"
			mat-raised-button
			color="primary"
			(click)="createTemplate(TransportSide.RETURN)"
		>
			Utwórz nowy szablon powrotny
		</button>
	</div>
</app-navbar>

<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
</div>

<mat-table [dataSource]="matData" matSort>
	<ng-container matColumnDef="id">
		<mat-header-cell *matHeaderCellDef class="mat-cell-id" mat-sort-header> Id</mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-id">{{ element.id }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="name">
		<mat-header-cell *matHeaderCellDef class="mat-cell-id" mat-sort-header> Nazwa</mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-id">{{ element.name }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="side">
		<mat-header-cell *matHeaderCellDef class="mat-cell-id" mat-sort-header> Kierunek</mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-id">{{
			element.side === TransportSide.DEPARTURE ? 'Wyjazd' : 'Powrót'
		}}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="show">
		<mat-header-cell *matHeaderCellDef class="mat-cell-id"></mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-id">
			<button mat-raised-button color="primary" class="show-button" (click)="show(element.id)">
				<span>Podgląd</span>
			</button>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="duplicate">
		<mat-header-cell *matHeaderCellDef class="mat-cell-id"></mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-id">
			<button mat-raised-button color="primary" (click)="duplicate(element.id)" class="duplicate-button">
				<span>Kopiuj</span>
			</button>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="update-name">
		<mat-header-cell *matHeaderCellDef class="mat-cell-id"></mat-header-cell>
		<mat-cell *matCellDef="let element" class="mat-cell-id">
			<button
				mat-raised-button
				color="primary"
				(click)="updateName(element.id, element.name)"
				class="update-name-button"
			>
				<span>Zmień nazwę</span>
			</button>
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let row; let element; columns: displayedColumns"></mat-row>
</mat-table>

<div class="footer">
	<mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="50"> </mat-paginator>
</div>
